import { get } from '../../object/get';
import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
/**
 * Gets a function used to do a date sort by the specified key in an object with a string value or date object at that key (for use with lodash/sortBy or lodash/orderBy)
 *
 * @aka sortByDate
 * @category Sorting
 * @template {T}
 * @param {string | symbol} key - The key in the object
 * @param {'h' | 'm' | 's'} [depth] - Compare depth of time, h/m/s
 * @returns {function} - The sorting function
 * @example
 * sortReduceDate('hireDate')({ hireDate: '01/01/2021' });
 * sortReduceDate('hireDate')({ hireDate: new Date() });
 * sortReduceDate('hireDate', 's')({ hireDate: new Date() });
 * @docgen_example
 * sortReduceDate('hireDate')({ hireDate: '01/01/2021' });
 */
export var sortReduceDate = function (key, depth) { return function (x) {
    var v = typeof key === 'symbol' ? x[key] : get(x, key);
    if (isNotNilOrEmpty(v)) {
        var d = typeof v === 'object' ? new Date(v.toUTCString()) : new Date((new Date(v.replace(/(z|Z)/g, ''))).toUTCString());
        var month = d.getMonth() >= 10 ? d.getMonth().toString() : '0' + d.getMonth().toString();
        var day = d.getDate() >= 10 ? d.getDate().toString() : '0' + d.getDate().toString();
        var hour = d.getHours() >= 10 ? d.getHours().toString() : '0' + d.getHours().toString();
        var minute = d.getMinutes() >= 10 ? d.getMinutes().toString() : '0' + d.getMinutes().toString();
        var second = d.getSeconds() >= 10 ? d.getSeconds().toString() : '0' + d.getSeconds().toString();
        var date = d.getFullYear().toString() + month + day;
        switch (depth) {
            case 'h':
                date += hour;
                break;
            case 'm':
                date += hour + minute;
                break;
            case 's':
                date += hour + minute + second;
                break;
        }
        return date;
    }
    return null;
}; };
